import ExportJsonExcel from 'js-export-excel';

export const handleExportToExcel = (xlsxData, callback = () => {}) => {
  const sheetHeader = [
    'Index',
    'Student Name',
    'Internal Student Id',
    'External Student Id',
    'Booking Number',
    'Phone Number',
    'Email',
    'Source Region',
    'Partner Code',
    'Booking Status',
    'Complete Date',
    'Created Date',
    'Owner Bc',
    'Destination University',
    'Booked Landlord',
    'Booked Property',
    'Booked Room Type',
    'Booked Move In Date',
    'Booked Move Out Date',
    'Booked Tenancy Length',
    'Landlord Booking Status',
    'Final Price',
    'Total Commission Charged',
    'Commission Converted Usd',
    'Commission Tier Name',
    'Agent Service Fee',
  ];

  const option = {};
  option['fileName'] = 'Booking -- Booking width Consultant';

  option['datas'] = [
    {
      sheetData: xlsxData,
      sheetHeader,
    },
  ];
  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
  callback();
};
